module.exports = __webpack_public_path__ + "static/force-orders-admin-vid-f373b41df2143d284d71a6c2ee59a935.mp4";